<template>
  <div style="background:#fff; padding:20px;">
    <div style="margin-bottom: 20px">
      <a-button type="primary" icon="plus" @click="handleAdd">新增角色</a-button>
    </div>

    <a-table :columns="columns" :data-source="data" rowKey="id" :loading="loading">
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">权限分配</a>
        <a-divider type="vertical" />
        <a-popconfirm title="确定删除该角色吗？关联的用户将失去该角色。" @confirm="handleDelete(record.id)">
          <a style="color: red">删除</a>
        </a-popconfirm>
      </span>
    </a-table>

    <a-modal v-model="visible" title="角色编辑" @ok="handleOk">
      <a-form-model :model="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
        <a-form-model-item label="角色名称">
          <a-input v-model="form.roleName" />
        </a-form-model-item>
        <a-form-model-item label="角色标识">
          <a-input v-model="form.roleKey" placeholder="如: admin" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <a-modal v-model="permVisible" title="分配菜单权限" :confirm-loading="permLoading" @ok="handlePermOk">
      <a-tree checkable check-strictly :tree-data="menuTree" :replace-fields="{children:'children', title:'title', key:'id'}"
        :checked-keys="{ checked: checkedKeys, halfChecked: [] }" default-expand-all @check="handleTreeCheck" />
    </a-modal>
  </div>
</template>

<script>
  import {
    getRoleList,
    getMenuList,
    getRoleMenuIds,
    assignRoleMenus,
    deleteRole
  } from '@/api' // 这里的api需要在api/index.js补充
  import request from '@/utils/request' // 直接引入 request 发送临时请求

  export default {
    data() {
      return {
        data: [],
        loading: false,
        visible: false,
        permVisible: false,
        form: {},
        columns: [{
          title: 'ID',
          dataIndex: 'id'
        }, {
          title: '角色名称',
          dataIndex: 'roleName'
        }, {
          title: '标识',
          dataIndex: 'roleKey'
        }, {
          title: '操作',
          key: 'action',
          scopedSlots: {
            customRender: 'action'
          }
        }],
        // 权限相关
        currentRoleId: null,
        menuTree: [],
        checkedKeys: [],
        permLoading: false
      }
    },
    created() {
      this.loadData()
    },
    methods: {
      loadData() {
        this.loading = true
        getRoleList().then(res => {
          this.data = res.data
          this.loading = false
        })
      },
      handleAdd() {
        this.form = {}
        this.visible = true
      },
      handleDelete(id) {
        deleteRole({ id: id }).then(() => {
          this.$message.success('删除成功');
          this.loadData();
        });
      },
      handleOk() {
        request.post('/role/add', this.form).then(() => {
          this.$message.success('保存成功')
          this.visible = false
          this.loadData()
        })
      },
      // 点击分配权限
      handleEdit(record) {
        this.currentRoleId = record.id
        this.permVisible = true
        this.checkedKeys = []
        this.permLoading = true
        Promise.all([
          getMenuList(),
          getRoleMenuIds(record.id)
        ]).then(([menuRes, roleMenuRes]) => {
          this.menuTree = menuRes.data || []
          this.checkedKeys = roleMenuRes.data || []
        }).finally(() => {
          this.permLoading = false
        })
      },
      handleTreeCheck(checkedKeys) {
        this.checkedKeys = checkedKeys.checked || checkedKeys || []
      },
      handlePermOk() {
        // 发送勾选的菜单ID
        assignRoleMenus({
          roleId: this.currentRoleId,
          menuIds: this.checkedKeys
        }).then(() => {
          this.$message.success('权限分配成功')
          this.permVisible = false
        })
      }
    }
  }
</script>
